import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38 38"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.793 8C13.805 8 13 8.804 13 9.793v16.996c0 .988.805 1.791 1.793 1.791h8.52c.988 0 1.79-.803 1.79-1.79V9.792c0-.989-.803-1.793-1.79-1.793zm0 .75h8.52c.574 0 1.04.468 1.04 1.043v1.021H13.75V9.793c0-.575.469-1.043 1.043-1.043zm-1.043 2.814h10.604v12.998H13.75zm3.941.448a.37.37 0 0 0-.263.11l-2.953 2.952a.377.377 0 1 0 .266.64.377.377 0 0 0 .265-.11l2.951-2.952a.375.375 0 0 0-.266-.64zm1.684.287a.374.374 0 0 0-.266.11l-4.537 4.536a.377.377 0 0 0 0 .532.375.375 0 0 0 .53 0l4.537-4.538a.375.375 0 0 0-.264-.64zm-1.559 3.47a.375.375 0 0 0-.265.11l-2.91 2.91a.375.375 0 0 0 .529.531l2.91-2.912a.373.373 0 0 0-.264-.638zm-4.066 9.543h10.604v1.477c0 .574-.468 1.041-1.042 1.041h-8.519a1.044 1.044 0 0 1-1.043-1.04zm5.303.393a.699.699 0 0 0-.698.697.699.699 0 0 0 1.395 0 .699.699 0 0 0-.697-.697z"
    }, null, -1)
  ])))
}
export default { render };